import axiosInstance from './axiosConfig';

const parseFilenameFromDisposition = (disposition) => {
  if (!disposition) return null;
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      /* ignore */
    }
  }
  const asciiMatch = disposition.match(/filename="?([^";]+)"?/i);
  return asciiMatch?.[1]?.trim() || null;
};

/**
 * Descarga el informe PDF de un participante desde el backoffice.
 */
export async function downloadInformePdf({ id_encuesta, id_usuario, nombreArchivoFallback }) {
  const response = await axiosInstance.post(
    '/gestionEncuestas/exportarInforme',
    { id_encuesta, id_usuario },
    { responseType: 'blob' }
  );

  const blob = new Blob([response.data], { type: 'application/pdf' });
  const filename =
    parseFilenameFromDisposition(response.headers['content-disposition']) ||
    nombreArchivoFallback ||
    'Informe_4_Creatividades.pdf';

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * Descarga el informe grupal (PPTX) de un equipo desde el backoffice.
 */
export async function downloadInformeGrupo({ id_encuesta, nombreArchivoFallback }) {
  const response = await axiosInstance.post(
    '/gestionEncuestas/exportarInformeGrupo',
    { id_encuesta },
    { responseType: 'blob' }
  );

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  });
  const filename =
    parseFilenameFromDisposition(response.headers['content-disposition']) ||
    nombreArchivoFallback ||
    'Informe Grupal 4 Creatividades.pptx';

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/** @deprecated alias — usa downloadInformeGrupo */
export const downloadInformeGrupoPdf = downloadInformeGrupo;

export async function downloadInformeGrupoWithErrorHandling(params) {
  try {
    await downloadInformeGrupo(params);
    return { ok: true };
  } catch (err) {
    if (err.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text();
        const json = JSON.parse(text);
        return { ok: false, message: json.message || 'Error al descargar el informe grupal' };
      } catch {
        /* ignore */
      }
    }
    return {
      ok: false,
      message: err.response?.data?.message || err.message || 'Error al descargar el informe grupal',
    };
  }
}

/** @deprecated alias */
export const downloadInformeGrupoPdfWithErrorHandling = downloadInformeGrupoWithErrorHandling;

export async function downloadInformePdfWithErrorHandling(params) {
  try {
    await downloadInformePdf(params);
    return { ok: true };
  } catch (err) {
    if (err.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text();
        const json = JSON.parse(text);
        return { ok: false, message: json.message || 'Error al descargar el informe' };
      } catch {
        /* ignore */
      }
    }
    return {
      ok: false,
      message: err.response?.data?.message || err.message || 'Error al descargar el informe',
    };
  }
}
